import React, { useState } from 'react'
import { useQuery, useMutation } from 'urql';
import { Card, Form, Input, Button, Select } from 'antd';

const PokemonsQuery = `
  query {
    Pokemons_Pokemon {
        id
        name
        power
        description
    }
  }
`;

const createBattle = `
  mutation CreateBattle($name: String!,$pokemon:String!,$description:String!) {
    insert_Pokemons_Battle(objects: { name: $name, pokemon: $pokemon, description: $description }) {
        returning {
            description
            id
            name
            pokemon
        }
    }
  }
`

const initialState = { name: '', pokemon: '', description: '' }

function BattleForm() {
    const [battle, setBattle] = useState(initialState)

    const [{ data, fetching, error }] = useQuery({
        query: PokemonsQuery,
    });

    const [mutationStatus, executeMutation] = useMutation(createBattle)

    const CreateBattle = () => {
        executeMutation({ ...battle })
        clear();
    }

    const clear = () => {
        setBattle(initialState)
    }

    const onChange = (type, value) => {
        setBattle({ ...battle, [type]: value })
    }

    return (
        <Card>
            <Form>
                <Form.Item label="Pokemon">
                    <Select onChange={(v, e) => onChange("pokemon", v)} value={battle.pokemon}>
                        {data && data.Pokemons_Pokemon.map(pokemon => (
                            <Select.Option key={pokemon.id}>{pokemon.name}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label="Name">
                    <Input onChange={(e) => onChange("name", e.target.value)} value={battle.name} />
                </Form.Item>
                <Form.Item label="Description">
                    <Input onChange={(e) => onChange("description", e.target.value)} value={battle.description} />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 18, span: 12 }}>
                    <Button htmlType="button" onClick={CreateBattle}>
                        Save
                    </Button>
                    <Button htmlType="button" onClick={clear} style={{ margin: '0 8px' }} >
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

export default BattleForm
